export const getUserName = (user: Data.User | Data.Author) => {
  return user
    ? `${user.last_name} ${user.first_name.length ? user.first_name[0] : ''}.${
        user.middle_name?.length ? user.middle_name[0] : ''
      }.`
    : ''
}
